/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type BetweenValueConfigKind = (typeof BetweenValueConfigKind)[keyof typeof BetweenValueConfigKind];

export const BetweenValueConfigKind = {
  between: 'between',
} as const;
